import styled, { css } from 'styled-components';

export const SearchItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 15px 35px;

  font-weight: 400;
  font-size: 16px;
  text-align: left;

  cursor: pointer;

  transition: background-color 0.3s;

  &:hover {
    background-color: #f8f8f8;
  }

  svg {
    margin-right: 10px;
  }

  .search-highlight {
    font-weight: 700;
    color: ${({ theme }) => theme.black};
    background-color: transparent;
  }

  ${({ isFocused }) => isFocused && css`
    background-color: #f8f8f8;
  `}

  ${({ isSelected }) => isSelected && css`
    font-weight: 700;
    background-color: #f8f8f8;
  `}
`;

export const SearchContainer = styled.div`
  height: 100%;

  .city-select {
    height: 100%;
    cursor: pointer;
  }

  .city-select__menu {
    width: 100%;
    min-width: 200px;

    ${({ compact }) => compact && css`
      width: 270px;
    `}
  }

  .city-select__control {
    height: 100%;

    &--is-focused .city-select__single-value {
      display: none;
    }

    ${({ compact }) => compact && css`
      &--is-focused .city-select__value-container {
        color: ${({ theme }) => theme.black};

        background-color: transparent;
      }
    `}
  }

  .city-select__value-container {
    position: relative;

    height: 100%;
    padding: 0 10px;

    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.black};

    @media(min-width: 768px) {
      font-size: 18px;
    }

    ${({ compact }) => compact && css`
      display: flex;
      align-items: center;
      height: 40px;
      padding: 0 15px;
      max-width: 200px;
      min-width: 100px;

      background-color: transparent;
      border: 1px solid #eeeeee;
      border-radius: 50px;

      transition: border-color 0.3s, background-color 0.3s, color 0.3s;

      &:hover {
        border-color: ${({ theme }) => theme.blue};
      }

      & > div:only-child {
        position: static;
        transform: none;

        overflow: hidden;
      }

      &--has-value {
        color: ${({ theme }) => theme.white};
        border-color: ${({ theme }) => theme.blue};
        background-color: ${({ theme }) => theme.blue};
      }
    `}
  }

  .city-select__single-value {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    width: 100%;
    padding-right: 30px;

    text-overflow: ellipsis;
    white-space: nowrap;

    overflow: hidden;

    ${({compact}) => compact && css`
      position: static;
      transform: none;

      padding-right: 0;
      font-size: 12px;
      
      @media (min-width: 400px) {
        font-size: 16px;
      }

      & + div {
        position: static;
        transform: none;
      }
    `}
  }
`;

export const SelectStyles = {
  container: () => ({
  }),
  control: () => ({
  }),
  valueContainer: () => ({
  }),
  singleValue: () => ({
  }),
  input: () => ({
    margin: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  }),
  menu: () => ({
    marginTop: 20,
    position: 'absolute',
    zIndex: '5',
    backgroundColor: '#ffffff',
    boxShadow: '0 12px 48px rgba(0, 0, 0, 0.1)',
    borderRadius: 6,
    overflow: 'hidden',
  }),
  menuList: () => ({
    maxHeight: 300,
    overflowY: 'auto'
  }),
  IndicatorsContainer: () => ({}),
};
